import { atom } from 'jotai';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';
import { IArticleUnavailableDetail, TArticleDetail } from 'shared/models/article';
import { Unreachable } from '@lemon8/web-app-shared/util';

type TArticleDetailStore = {
  [key: string]: TArticleDetail | IArticleUnavailableDetail | undefined;
};

const $ArticleDetailStore = atom({} as TArticleDetailStore);
$ArticleDetailStore.debugLabel = '$ArticleDetailStore';

export const $ArticleDetail = safeAtomFamily((groupId: string) => {
  const a = atom(
    (get) => {
      const data = get($ArticleDetailStore)[groupId];
      if (!data) {
        return Unreachable();
      }
      return data;
    },
    (get, set, input: TArticleDetail | IArticleUnavailableDetail) => {
      const old = get($ArticleDetailStore);
      set($ArticleDetailStore, {
        ...old,
        [groupId]: input,
      });
    },
  );

  a.debugLabel = `$ArticleDetail+${encodeURIComponent(groupId)}`;

  return a;
});
